
const rules = {
  // The dispatch cutoff time for for each day of the week (sun=0, mon=1, ...)
  // If the value is null, there is no dispatch on that day.
  dispatchCutoffTimes:{
    0: null,
    1: "15:00",
    2: "15:00",
    3: "15:00",
    4: "15:00",
    5: "15:00",
    6: "11:30",
    "bankHolidays": null,
  },

  // The nominal number of days from dispatch to delivery
  daysUntilDelivery: 1,

  // Days of the week on which deliveries are made (sun=0, mon=1, ...)
  deliveryDays: [0, 1, 2, 3, 4, 5, 6],

  // Whether deliveries are made on bank holidays
  deliverOnBankHolidays: false,

  // List of bank holidays
  bankHolidays: [
    '2024-05-06',
    '2024-05-27',
    '2024-08-26',
    '2024-12-25',
    '2024-12-26',
    '2025-04-18',
    '2025-04-21',
    '2025-05-05',
    '2025-08-25',
    '2025-12-25',
    '2025-12-26',
    '2026-01-01',
    '2026-04-03',
    '2026-04-06',
    '2026-05-04',
    '2026-05-25',
    '2026-08-31',
    '2026-12-25',
    '2026-12-26',
    '2027-01-01',
    '2027-03-26',
    '2027-03-29',
    '2027-05-03',
    '2027-05-31',
    '2027-08-31',
    '2027-12-27',
    '2027-12-28',
  ],
};


class DeliveryCalculator{
  constructor(rules){
    this.rules = rules;
  }

  /* Returns an object with hours, minutes, and seconds properties, parsed from
  the given string, in the format "hh[:mm[:ss]]". Parts not given default to 0 */
  _getTimePartsFromString(s){
    let parts = s.split(":");
    if(parts.length < 1 || parts.length > 3){
      throw new Error("Invalid time format");
    }

    let t = {"hours":0, "minutes":0, "seconds":0};
    if(parts.length >= 1){
      t.hours = parseInt(parts[0]);
    }
    if(parts.length >= 2){
      t.minutes = parseInt(parts[1]);
    }
    if(parts.length >= 3){
      t.seconds = parseInt(parts[2]);
    }
    return t;
  }

  /* Returns whether the given date is a bank holiday */
  _isBankHoliday(date){
    const dateString = date.toISOString().split('T')[0]; // Format date as 'YYYY-MM-DD'
    return this.rules.bankHolidays.includes(dateString);
  }

  /* Returns whether deliveries are made on the given date */
  _isDeliveryDay(date){
    return this.rules.deliveryDays.includes(date.getDay()) 
      && (!this._isBankHoliday(date) || this.rules.deliverOnBankHolidays);
  }

  /* Starting from `now`, returns a Date which represents the next dispatch
     cutoff time */ 
  getNextDispatchCutoff(now){
    let cutoffDate = new Date(now);

    while(true){
      let cutoffTimeStr;

      // get the cutoff time for today, or null if no dispatch today
      if(this._isBankHoliday(cutoffDate)){
        cutoffTimeStr = this.rules.dispatchCutoffTimes["bankHolidays"];
      }
      else{
        cutoffTimeStr = this.rules.dispatchCutoffTimes[cutoffDate.getDay()];
      }

      // if we have a cutoff time, and it's in the future, we're done
      if (cutoffTimeStr != null){
        const cutoffTime = this._getTimePartsFromString(cutoffTimeStr);
        cutoffDate.setHours(cutoffTime.hours, cutoffTime.minutes, cutoffTime.seconds);
        if(cutoffDate > now){
          break;
        }
      }
      
      cutoffDate.setDate(cutoffDate.getDate() + 1);
    }

    return cutoffDate;
  }

  /* Starting from `dispatchDate`, returns a Date which represents the expected
      delivery day */
  getDeliveryDate(dispatchDate){
    let deliveryDay = new Date(dispatchDate);

    // add the nominal number of days until delivery
    deliveryDay.setDate(deliveryDay.getDate() + this.rules.daysUntilDelivery);

    //..and then keep adding days until we land on an actual delivery day
    while(!this._isDeliveryDay(deliveryDay)){
      deliveryDay.setDate(deliveryDay.getDate() + 1);
    }
    
    return deliveryDay;
  }
}

// cache these from the previous call so we don't have to recalculate them on
// each timer update
let cutoff = null;
let deliveryDayStr = null;

function getDeliveryCountdown(){
  const now = new Date();

  // if no previous cutoff, or cutoff has passed, then recalculate
  if(cutoff == null || cutoff <= now){
    const calculator = new DeliveryCalculator(rules);
    cutoff = calculator.getNextDispatchCutoff(now);
    console.log(`Next dispatch cutoff: ${cutoff}`);

    const deliveryDate = calculator.getDeliveryDate(cutoff);
    deliveryDayStr = deliveryDate.toLocaleDateString('en-GB', { weekday: 'long' });
  }
  
  const msLeft = cutoff - now;
  const hours = Math.floor(msLeft / (1000 * 60 * 60));
  const minutes = Math.floor((msLeft / (1000 * 60)) % 60);
  const seconds = Math.floor((msLeft / 1000) % 60);

  return `<span>Order in ${hours}h ${minutes}m ${seconds}s</span> for delivery on ${deliveryDayStr}`;
}

// Example usage: Update the dispatch time every second
setInterval(() => {
    const dispatchTimeElement = document.querySelector('.dispatch-time');
    if (dispatchTimeElement) {
        dispatchTimeElement.innerHTML = getDeliveryCountdown();
    }
}, 1000);
